import { IndividualsPanel } from '@src/components/IndividualsPanel/IndividualsPanel'
import cn from 'classnames'
import React, {
  useCallback, useEffect,
  useMemo, useRef, useState,
} from 'react'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'

import style
  from '@src/pages/TerminationAgreement/TerminationAgreement.module.scss'
import { Footer } from '@src/components/Footer/Footer'
import { FirstStep } from '@src/pages/TerminationAgreement/steps/FirstStep'
import { SecondStep } from '@src/pages/TerminationAgreement/steps/SecondStep'
import { Direction } from '@src/pages/TerminationAgreement/steps/Enum'
import { ReturnBtn } from '@src/components/Button/ReturnBtn'
import { phoneRegexp } from '@src/lib/regex'
import { validateForm } from '@src/messages/validateForm'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectIsSuccessTerminationAgreements,
  selectTerminationCauses,
  selectUserListAddresses,
} from '@src/store/ducks/user/selectors'
import { AppDispatch } from '@src/store/store'
import { getTerminationCauses, terminationAgreements } from '@src/store/ducks/user/thunks'
import { Modal } from '@src/components/common/Modal/Modal'
import {
  setIsSuccessTerminationAgreements,
} from '@src/store/ducks/user/reducer'
import { Button } from '@src/components/Button/Button'
import { NavLink } from 'react-router-dom'
import { setPageTitle } from '@src/store/ducks/app/reducer'

export const TerminationAgreement = () => {
  const formRef = useRef<any>()
  const dispatch = useDispatch<AppDispatch>()

  const listAddresses = useSelector(selectUserListAddresses)
  const isSuccessSendMessage = useSelector(selectIsSuccessTerminationAgreements)
  const terminationCauses = useSelector(selectTerminationCauses)
  const [step, setStep] = useState<Direction>(Direction.Step1)
  const [isOpenModal, setIsOpenModal] = useState(true)

  useEffect(() => { dispatch(setPageTitle('Расторгнуть договор')) }, [dispatch])

  useEffect(() => {
    dispatch(getTerminationCauses())
  }, [dispatch])

  const validationSchema = useMemo(() => (
    Yup.object().shape({
      phone: Yup.string().matches(phoneRegexp, validateForm.phone).required(validateForm.required),
    })
  ), [])

  const checkBoxOptions = useMemo(() => terminationCauses.map((item, i) => ({
    id: `${i}`,
    name: `remember${i}`,
    description: item,
  })), [terminationCauses])

  const initialValues = useMemo(() => ({
    checkBoxQuestion: null,
    comment: '',
    phone: '',

  }), [])

  const closeModal = useCallback(() => {
    dispatch(setIsSuccessTerminationAgreements(false))
    setIsOpenModal(false)
  }, [dispatch])

  return (
    <div>
      <IndividualsPanel />
      <div className={cn(style.tariffContainer, 'container')}>
        {/* <Button */}
        {/*  onClickFunc={() => ((step === Direction.Step1) ? history.goBack() : setStep(step - 1))} */}
        {/*  icon={<Arrow />} */}
        {/*  className={style.returnBtn} */}
        {/*  type="secondary" */}
        {/* > */}
        {/*  Вернуться */}
        {/* </Button> */}
        {(step === Direction.Step1)
          ? (
            <ReturnBtn
              type="secondary"
              className={style.returnBtn}
            >
              Вернуться
            </ReturnBtn>
          ) : (
            <ReturnBtn
              type="secondary"
              className={style.returnBtn}
            >
              Вернуться
            </ReturnBtn>
          )}
        <Formik
          validationSchema={validationSchema}
          initialValues={initialValues}
          onSubmit={(values) => {
            // eslint-disable-next-line max-len
            dispatch(terminationAgreements(listAddresses[0].account, listAddresses[0].accountId, `${checkBoxOptions.find((item) => item.id === values.checkBoxQuestion)?.description} | ${values.comment} | ${values.phone}`))
            setIsOpenModal(true)
          }}
          innerRef={formRef}
        >
          {() => (
            <Form>
              {step === Direction.Step1 && (
                <FirstStep
                 // value={value}
                  step={step}
                  onClick={setStep}
                  checkBoxQuestions={checkBoxOptions}
                />
              )}
              {step === Direction.Step2 && <SecondStep />}
              {/* {step === Direction.Step3 && <SecondStep />} */}
            </Form>
          )}
        </Formik>
      </div>
      <Footer />
      <Modal isOpen={isSuccessSendMessage} close={closeModal}>
        {isOpenModal && (
          <>
            <div className={style.confirmActions}>
              Ваша заявка была
              <span className="blue"> успешно оформлена!</span>
              {' '}
            </div>
            <NavLink to="/">
              <Button className={style.btnPosition} type="primary">
                В личный кабинет
              </Button>
            </NavLink>
          </>
        )}
      </Modal>
    </div>
  )
}
